import CheckPromotion from '../components/checkPromotion';

class PromotoinCodeScreen {
  constructor() {
    this._setup();
  }

  _setup() {
    new CheckPromotion();
  }
}

if (document.querySelector('#promotion_code')) {
  new PromotoinCodeScreen();
}



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/PromotionCode.js